import styled from 'styled-components';

export const LandingContainer = styled.div`
  min-height: 100vh;
  background: var(--app-bg-gradient);
  position: relative;
  overflow-x: hidden;
`;

export const Navbar = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: var(--surface-overlay);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-md);
  border-bottom: 2px solid var(--accent);
  z-index: 1000;

  @media (max-width: 768px) {
    padding: 0.8rem 1rem;
  }
`;

export const NavLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

export const NavRight = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: 768px) {
    gap: 0.5rem;
  }
`;

export const NavItems = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    background: var(--accent-soft);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const HamburgerLine = styled.span`
  width: 24px;
  height: 3px;
  background: var(--accent-secondary);
  border-radius: 2px;
  transition: all 0.3s ease;
  transform-origin: center;

  &.open:nth-child(1) {
    transform: rotate(45deg) translate(6px, 6px);
  }

  &.open:nth-child(2) {
    opacity: 0;
  }

  &.open:nth-child(3) {
    transform: rotate(-45deg) translate(6px, -6px);
  }
`;

export const MobileMenu = styled.div`
  display: none;
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  background: var(--surface-overlay);
  backdrop-filter: blur(15px);
  border-bottom: 2px solid var(--accent);
  box-shadow: var(--shadow-lg);
  z-index: 999;
  transform: translateY(-100%);
  transition: transform 0.3s ease;
  padding: 1rem;

  &.open {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileNavItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: stretch;
`;

export const MobileNavItem = styled.span`
  color: var(--text-secondary);
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  padding: 1rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  text-align: center;
  border: 1px solid transparent;

  &:hover {
    color: var(--accent-secondary);
    background: var(--accent-soft);
    border-color: var(--border-default);
    transform: translateY(-2px);
    box-shadow: var(--shadow-sm);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const MobileNavLink = styled.a`
  color: var(--text-secondary);
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  padding: 1rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  text-align: center;
  text-decoration: none;
  border: 1px solid transparent;
  display: block;

  &:hover {
    color: var(--accent-secondary);
    background: var(--accent-soft);
    border-color: var(--border-default);
    transform: translateY(-2px);
    box-shadow: var(--shadow-sm);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const MobileNavItemDisabled = styled.span`
  color: var(--text-muted);
  font-size: 1.1rem;
  font-weight: 500;
  cursor: not-allowed;
  padding: 1rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  text-align: center;
  border: 1px solid var(--border-subtle);
  background: var(--accent-soft);
`;

export const NavItem = styled.span`
  color: var(--text-secondary);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  user-select: none;

  &:hover {
    color: var(--accent-secondary);
    background: var(--accent-soft);
    box-shadow: var(--shadow-sm);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--accent-soft), transparent);
    transition: left 0.5s ease;
  }

  &:hover::before {
    left: 100%;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }
`;

export const NavItemDisabled = styled.span`
  color: var(--text-muted);
  font-size: 1rem;
  font-weight: 500;
  cursor: not-allowed;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  user-select: none;

  &:hover {
    color: var(--text-secondary);
    background: var(--accent-soft);
    box-shadow: var(--shadow-sm);
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }
`;

export const NavLink = styled.a`
  color: var(--text-secondary);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  user-select: none;

  &:hover {
    color: var(--accent-secondary);
    background: var(--accent-soft);
    box-shadow: var(--shadow-sm);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--accent-soft), transparent);
    transition: left 0.5s ease;
  }

  &:hover::before {
    left: 100%;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoImage = styled.img`
  width: 200px;
  height: auto;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 150px;
  }
`;

export const NavButton = styled.button`
  background: var(--accent-soft);
  border: 2px solid var(--accent);
  color: var(--accent-secondary);
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: var(--accent);
    border-color: var(--accent);
    color: var(--text-on-accent);
    box-shadow: var(--shadow-md);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 8rem 2rem 4rem;
  min-height: 100vh;
`;

export const HeroTitle = styled.h4`
  font-size: 2.5rem;
  color: var(--text-heading);
  margin-bottom: 2rem;
  text-shadow: 2px 2px 4px var(--surface-overlay);
  font-weight: 500;
  line-height: 1.2;
  max-width: 900px;

  @media (max-width: 768px) {
    font-size: 2.5rem;
    padding: 0 1rem;
  }
`;

export const HeroSubtitle = styled.p`
  font-size: 1.4rem;
  color: var(--text-secondary);
  margin-bottom: 3rem;
  max-width: 800px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    padding: 0 1rem;
  }
`;

/* CTA principal mantém o gradiente de marca (verde/azul Vert) em ambos os temas. */
export const CTAButton = styled.button`
  background: var(--brand-cta-gradient);
  color: rgb(222, 250, 157);
  border: none;
  padding: 1.2rem 2.5rem;
  border-radius: 50px;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-md);
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover {
    background: var(--brand-cta-gradient-hover);
    box-shadow: var(--shadow-lg);
    transform: translateY(-3px);
  }

  &:active {
    transform: translateY(-1px);
  }
`;

export const DevelopmentNotice = styled.div`
  background: var(--surface-overlay);
  border: 2px solid var(--accent);
  border-radius: 20px;
  padding: 3rem 2rem;
  margin: 2rem;
  text-align: center;
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-md);
`;

export const DevelopmentTitle = styled.h2`
  font-size: 2rem;
  color: var(--accent);
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px var(--surface-overlay);
  font-weight: 700;
`;

export const DevelopmentText = styled.p`
  font-size: 1.1rem;
  color: var(--text-secondary);
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
`;
